import axios from 'axios';
import { API_BASE_URL } from '../../config/api';
import { format, parseISO } from 'date-fns';

export interface BusinessStat {
  businessId: string;
  name: string;
  status: string;
  joinedAt: string;
  totalChecks: number;
  completedChecks: number;
  checksToday: number;
  checksWeek: number;
  checksMonth: number;
  lastActive: string | null;
}

export interface DvlaBusinessStat {
  businessId: string;
  name: string;
  status: string;
  remainingCredits: number | null;
  totalDvlaChecks: number;
  completedDvlaChecks: number;
  failedDvlaChecks: number;
  dvlaToday: number;
  dvlaWeek: number;
  dvlaMonth: number;
  lastDvlaCheck: string | null;
}

export interface PlatformStats {
  checksToday: number;
  checksThisWeek: number;
  checksThisMonth: number;
  totalChecks: number;
  activeBusinesses7d: number;
  activeBusinesses30d: number;
  daily: { date: string; count: number }[];
  weekly: { week: string; count: number }[];
  monthly: { month: string; count: number }[];
  businesses: BusinessStat[];
  newBusinesses: { month: string; count: number }[];
  checksByType: { type: string; count: number }[];
  totalDvlaChecks: number;
  completedDvlaChecks: number;
  failedDvlaChecks: number;
  dvlaChecksThisMonth: number;
  dvlaBusinesses: DvlaBusinessStat[];
}

export type ChartPeriod = 'daily' | 'weekly' | 'monthly';

export const formatChartDate = (str: string, period: ChartPeriod): string => {
  try {
    if (period === 'monthly') return format(parseISO(str + '-01'), 'MMM yy');
    if (period === 'weekly') return format(new Date(str), 'dd MMM');
    return format(parseISO(str), 'dd MMM');
  } catch {
    return str;
  }
};

export async function fetchPlatformStats(): Promise<PlatformStats> {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('Not authenticated');

  const response = await axios.get(`${API_BASE_URL}/owner/platform-stats`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.data?.success) {
    throw new Error(response.data?.message || 'Failed to load platform stats');
  }

  return response.data as PlatformStats;
}
